import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID, // Make sure this is set correctly
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
const firebaseConfigCentral = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY_CENTRAL,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_CENTRAL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_CENTRAL, // Make sure this is set correctly
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_CENTRAL,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_CENTRAL,
  appId: process.env.REACT_APP_FIREBASE_APP_ID_CENTRAL,
};
// Initialize Firestore

export const app = initializeApp(firebaseConfig);
export const appCentral = initializeApp(firebaseConfigCentral, "central");

// Initialize Firestore and Auth
//export const dbCentral = getFirestore(appCentral);
export const dbCentral = getFirestore(appCentral);

// export const auth = getAuth(app);
// export a getAuthCentral function to get the auth instance for the central app
export const getAuthCentral = () => {
  return getAuth(appCentral);
};

// Initialize Firestore and Auth
export const db = getFirestore(app);
export const auth = getAuth(appCentral);

export default app;
